var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvailable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 23,
    fill: "none",
    viewBox: "0 0 24 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1E90FF",
    fillRule: "evenodd",
    d: "M18 3h-1V2c0-.552-.448-1-1-1s-1 .448-1 1v1H9V2c0-.552-.448-1-1-1s-1 .448-1 1v1H6C4.343 3 3 4.343 3 6v12c0 1.657 1.343 3 3 3h12c1.657 0 3-1.343 3-3V6c0-1.657-1.343-3-3-3zm1 3v11c0 1.105-.895 2-2 2H7c-1.105 0-2-.895-2-2V6c0-.552.448-1 1-1h1v1c0 .552.448 1 1 1s1-.448 1-1V5h6v1c0 .552.448 1 1 1s1-.448 1-1V5h1c.552 0 1 .448 1 1z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1E90FF",
    fillRule: "evenodd",
    d: "M15.697 9.282c.396.385.405 1.018.02 1.415l-3.882 4c-.188.194-.447.303-.717.303-.27 0-.53-.11-.718-.303l-2.118-2.182c-.384-.397-.375-1.03.022-1.414.396-.385 1.029-.376 1.414.02l1.4 1.443 3.164-3.26c.385-.397 1.018-.406 1.415-.022z",
    clipRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvailable);
export default __webpack_public_path__ + "static/media/available.abde01e4116373c115b080e698eec7dd.svg";
export { ForwardRef as ReactComponent };